/******/ (() => { // webpackBootstrap
/*!****************************************!*\
  !*** ./src/js/templates/collection.js ***!
  \****************************************/
/*
* Events:
* sort-change: Triggered when the sorting select input has been changed. The value is in event.detail.sort.
*   Will trigger a facet-filters-refresh event so the page is refreshed.
* facet-filters-refresh: Used to refresh the collection page using ajax.
*
* */

class SortSelect extends HTMLElement {
  constructor() {
    super();
    this.querySelector('select').addEventListener('change', () => {
      this.dispatchEvent(new CustomEvent('sort-change', {
        bubbles: false,
        composed: true,
        detail: {
          sort: this.querySelector('select').value
        }
      }));
    });
    this.addEventListener('sort-change', e => {
      var currentSortValue = e.detail.sort;
      var $sortInput = document.querySelector('[name="sort_by"]');
      if ($sortInput && currentSortValue) {
        $sortInput.value = currentSortValue;
      }

      // We get the first facet-filters and trigger the refresh event to update the product grid and filters.
      const facetFilters = document.querySelector('facet-filters-form');
      facetFilters.dispatchEvent(new CustomEvent('facet-filters-refresh'));
    });
  }
}
customElements.define('sort-select', SortSelect);
class SingleFilter extends HTMLElement {
  constructor() {
    super();
    var currentElement = this;
    var currentFilterId = this.id;
    var $currentFilter = this.querySelector('#single-filter-title__' + currentFilterId);
    $currentFilter.addEventListener('click', e => {
      if (currentElement.classList.contains('opened')) {
        SingleFilter.closeFilter(currentElement);
      } else {
        SingleFilter.openFilter(currentElement);
      }
    });
  }
  static openFilter(element) {
    element.classList.add('opened');
  }
  static closeFilter(element) {
    element.classList.remove('opened');
  }
}
customElements.define('single-filter', SingleFilter);
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.updateCollectionData = event => {
      this.addFilterTracking(event);
      debounce(event => {
        document.getElementById('ProductGridContainer').classList.add('opacity-50');
        this.onSubmitHandler(event);
      }, 500)(event);
    };
    var $form = this.querySelector('form');
    if ($form) {
      $form.addEventListener('change', this.updateCollectionData);
    }
    this.addEventListener('facet-filters-refresh', this.updateCollectionData);
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }
  addFilterTracking(event) {
    const input = event.target;
    let inputValue;
    let sendTracking = true;
    if (input.type === 'checkbox') {
      inputValue = input.checked;
      if (!inputValue) {
        sendTracking = false;
      }
    } else {
      inputValue = input.value;
    }
    if (sendTracking && input.dataset && input.dataset.groupLabel) {
      const groupLabel = input.dataset.groupLabel;
      let filterLabel = '';
      if (input.type === 'checkbox') {
        filterLabel = input.dataset.filterLabel;
      } else {
        filterLabel = input.dataset.filterLabel + ': ' + inputValue;
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'filters',
        'filterLabel': groupLabel,
        'filterValue': filterLabel
      });
    }
  }
  static setListeners() {
    const onHistoryChange = event => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }
  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach(element => {
      element.classList.toggle('disabled', disable);
    });
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const params = new URLSearchParams(searchParams);

    // If the price range is not set, remove it from the search params
    if (parseInt(params.get('filter.v.price.gte')) === 0) {
      params.delete('filter.v.price.gte');
    }

    // If the price range is equal to the max, remove it from the search params
    var minRange = document.querySelector('[name="filter.v.price.lte"]');
    if (!minRange || parseInt(params.get('filter.v.price.lte')) === parseInt(minRange.getAttribute('max'))) {
      params.delete('filter.v.price.lte');
    }
    sections.forEach(section => {
      const url = `${window.location.pathname}?section_id=${section.section}&${params.toString()}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(params.toString());
  }
  static renderSectionFromFetch(url, event) {
    fetch(url).then(response => response.text()).then(responseText => {
      const html = responseText;
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
        html,
        url
      }];
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderPagination(html);
      FacetFiltersForm.renderSort(html);
      document.getElementById('ProductGridContainer').classList.remove('opacity-50');
    });
  }
  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderPagination(html);
    FacetFiltersForm.renderSort(html);
    document.getElementById('ProductGridContainer').classList.remove('opacity-50');
  }
  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }
  static renderPagination(html) {
    var $pagination = new DOMParser().parseFromString(html, 'text/html').getElementById('grid-pagination');
    if ($pagination) {
      document.getElementById('grid-pagination').innerHTML = $pagination.innerHTML;
    }
  }
  static renderFilters(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newCollectionFilters = parsedHTML.getElementById('FacetFiltersForm');
    document.querySelector('#FacetFiltersForm').innerHTML = newCollectionFilters.innerHTML;
  }
  static renderSort(html) {
    const sortElement = document.querySelector('#sort-label');
    if (!sortElement) {
      return;
    }
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newSort = parsedHTML.getElementById('sort-label');
    sortElement.innerHTML = newSort.innerHTML;
  }
  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [{
      section: document.getElementById('product-grid').dataset.id
    }];
  }
  onSubmitHandler(event) {
    event.preventDefault();
    var $form = this.querySelector('form');
    let searchParams = '';
    if ($form) {
      const formData = new FormData($form);
      searchParams = new URLSearchParams(formData).toString();
    }
    FacetFiltersForm.renderPage(searchParams, event);
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
  constructor() {
    super();

    // Inputs
    var $minRangeInput = this.querySelector('.price-range__min-input');
    var $maxRangeInput = this.querySelector('.price-range__max-input');

    // Balls
    var $minRangeInputBall = this.querySelector('.price-range__min-ball');
    var $maxRangeInputBall = this.querySelector('.price-range__max-ball');

    // Price bubbles
    var $minRangeInputText = this.querySelector('.price-range__min-number');
    var $maxRangeInputText = this.querySelector('.price-range__max-number');

    // Range bar
    var $rangeBar = this.querySelector('.price-range__range-bar');
    $minRangeInput.addEventListener('input', function (event) {
      var $minRangeInputValue = parseInt($minRangeInput.value);
      var $maxRangeInputValue = parseInt($maxRangeInput.value);
      if ($minRangeInputValue > $maxRangeInputValue) {
        $minRangeInput.value = $minRangeInput.getAttribute('min');
        $minRangeInputValue = parseInt($minRangeInput.value);
      }
      var $minRangeInputPercentage = 100 * ($minRangeInput.value - $minRangeInput.getAttribute('min')) / ($maxRangeInput.getAttribute('max') - $minRangeInput.getAttribute('min'));
      var $maxRangeInputPercentage = 100 * ($maxRangeInputValue - $minRangeInput.getAttribute('min')) / ($minRangeInput.getAttribute('max') - $minRangeInput.getAttribute('min'));
      $minRangeInputBall.style.left = $minRangeInputPercentage + '%';
      $minRangeInputText.innerHTML = Axial.formatMoney($minRangeInputValue * 100, false, 0);
      $rangeBar.style.left = $minRangeInputPercentage + '%';
      $rangeBar.style.width = $maxRangeInputPercentage - $minRangeInputPercentage + '%';
    });
    $maxRangeInput.addEventListener('input', function (event) {
      var $minRangeInputValue = parseInt($minRangeInput.value);
      var $maxRangeInputValue = parseInt($maxRangeInput.value);
      if ($maxRangeInputValue < $minRangeInputValue) {
        $maxRangeInput.value = $maxRangeInput.getAttribute('max');
        $maxRangeInputValue = parseInt($maxRangeInput.value);
      }
      var $minRangeInputPercentage = 100 * ($minRangeInput.value - $minRangeInput.getAttribute('min')) / ($maxRangeInput.getAttribute('max') - $minRangeInput.getAttribute('min'));
      var $maxRangeInputPercentage = 100 * ($maxRangeInputValue - $minRangeInput.getAttribute('min')) / ($minRangeInput.getAttribute('max') - $minRangeInput.getAttribute('min'));
      $maxRangeInputBall.style.left = $maxRangeInputPercentage + '%';
      $maxRangeInputText.innerHTML = Axial.formatMoney($maxRangeInputValue * 100, false, 0);
      $rangeBar.style.left = $minRangeInputPercentage + '%';
      $rangeBar.style.width = $maxRangeInputPercentage - $minRangeInputPercentage + '%';
    });
  }
}
customElements.define('price-range', PriceRange);
function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');
  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }
  summary.addEventListener('click', event => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN'];
  let currentFocusedElement = null;
  let mouseClick = null;
  window.addEventListener('keydown', event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });
  window.addEventListener('mousedown', event => {
    mouseClick = true;
  });
  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');
  }, true);
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
}
function initMobileFiltersMenu() {
  var mobileFilters = document.querySelector('.show-filters-menu-action');
  if (mobileFilters) {
    mobileFilters.addEventListener('click', function (e) {
      var filters = document.querySelector('.collection-grid');
      filters.classList.toggle('showing-filters');
      Axial.toggleOverlay('filters-overlay-open');
    });
  }
}
initMobileFiltersMenu();
/******/ })()
;